import React, { useEffect, useState } from 'react';
import Method from "../components/Method";
import Attributes from "../components/Attributes";
import Layout from "../layout";
import {Helmet} from "react-helmet";
import { useTranslation } from 'react-i18next';

const RateObject = (props) => {
    const { t, i18n } = useTranslation();

    return (
        <Layout children={props.children} location={props.location}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{t('docs.rates.object.metaTitle')}</title>
                <meta name="description" content={t('docs.rates.object.metaDescription')}/>
                <link rel="canonical" href="https://biteship.com/docs/api/rates" />
            </Helmet>

            <div className="row">
                <div className="col-md-8">
                    <h1>{t('docs.rates.object.title')} </h1>
                    <br/>
                    <p>{t('docs.rates.object.description')}</p>
                    <br/>
                    <Method title={"ENDPOINTS"} white>
                        <a href="/docs/api/rates" className="text-decoration-none">
                            <text className="text-black-50"><b className="text-success">POST</b> /v1/rates/couriers <text className="text-muted-light">// by coordinate</text></text><br/>
                            <text className="text-black-50"><b className="text-success">POST</b> /v1/rates/couriers <text className="text-muted-light">// by postal code</text></text><br/>
                            <text className="text-black-50"><b className="text-success">POST</b> /v1/rates/couriers <text className="text-muted-light">// by area id</text></text><br/>
                            <text className="text-black-50"><b className="text-success">POST</b> /v1/rates/couriers <text className="text-muted-light">// by mix</text></text><br/>
                        </a>
                    </Method>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-md-8">
                    <h2 className="h3">The rate object</h2>
                    <br/>
                    <p>List of all attributes in the courier object</p>
                    <Attributes data={attributes}/>
                </div>
            </div>
            <br/>
            <br/>
            <div className="row">
                <div className="col-md-8">
                    <p className="text-muted"><b>Mengenai API Cek Ongkir</b></p>
                    <p className="text-muted">Gunakan API Cek Ongkir atau API Cek Ongkos Kirim Biteship untuk memudahkan pengiriman Anda sehari-hari. API Cek Ongkir Biteship telat terintegrasi dengan berbagai macam kuir, mulai dari kurir instant sampai kurir trucking. API Cek Ongkir Biteship sangat berguna jika Anda memiliki platform atau website yang menawarkan berbagai macam kurir, karena API Cek Onkir Biteship menawarkan mulai dari pengiriman dalam negri dan juga ke luar negri. Anda dapat melihat Dokumentasi API Cek Ongkir Biteship secara lengkap melalui halaman ini. </p>
                </div>
            </div>
            <br/>
            <br/>
        </Layout>
    )
};

const attributes = [{
    name:'origin',
    type:'object',
    description:'Origin object',
    items: [
        {
            name:'latitude',
            type:'double',
            description:'Latitude of the location'
        },
        {
            name:'longitude',
            type:'double',
            description:'Longitude of the location'
        },
        {
            name:'postal_code',
            type:'integer',
            description:'The postal code of area',
        },
        {
            name:'country_name',
            type:'string',
            description:'The name of the country',
        },
        {
            name:'country_code',
            type:'string',
            description:'Three-letter ISO 3166-1 Country Code',
        },
        {
            name:'administrative_division_level_1_name',
            type:'string',
            description:'First-level of administrative division name',
        },
        {
            name:'administrative_division_level_1_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, Province' ,
        },
        {
            name:'administrative_division_level_2_name',
            type:'string',
            description:'Second-level of administrative division name',
        },
        {
            name:'administrative_division_level_2_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, City' ,
        },
        {
            name:'administrative_division_level_3_name',
            type:'string',
            description:'Third-level of administrative division name',
        },
        {
            name:'administrative_division_level_3_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, District' ,
        },
        {
            name:'administrative_division_level_4_name',
            type:'string',
            description:'Fourth-level of administrative division name',
        },
        {
            name:'administrative_division_level_4_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, Subdistrict' ,
        }
    ]
},{
    name:'destination',
    type:'object',
    description:'Destination object',
    items: [
        {
            name:'latitude',
            type:'double',
            description:'Latitude of the location'
        },
        {
            name:'longitude',
            type:'double',
            description:'Longitude of the location'
        },
        {
            name:'postal_code',
            type:'integer',
            description:'The postal code of area',
        },
        {
            name:'country_name',
            type:'string',
            description:'The name of the country',
        },
        {
            name:'country_code',
            type:'string',
            description:'Three-letter ISO 3166-1 Country Code',
        },
        {
            name:'administrative_division_level_1_name',
            type:'string',
            description:'First-level of administrative division name',
        },
        {
            name:'administrative_division_level_1_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, Province' ,
        },
        {
            name:'administrative_division_level_2_name',
            type:'string',
            description:'Second-level of administrative division name',
        },
        {
            name:'administrative_division_level_2_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, City' ,
        },
        {
            name:'administrative_division_level_3_name',
            type:'string',
            description:'Third-level of administrative division name',
        },
        {
            name:'administrative_division_level_3_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, District' ,
        },
        {
            name:'administrative_division_level_4_name',
            type:'string',
            description:'Fourth-level of administrative division name',
        },
        {
            name:'administrative_division_level_4_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, Subdistrict' ,
        }
    ]
},{
    name:'pricing',
    type:'array',
    description:'Array of courier rates',
    items:[{
        name:'courier_name',
        type:'string',
        description:'Brand name for the courier'
    },{
        name:'courier_code',
        type:'string',
        description:'Unique for the courier'
    },{
        name: 'courier_service_name',
        type: 'string',
        description: 'The commercial name of the service  '
    },{
        name: 'courier_service_code',
        type: 'string',
        description: 'The code of the courier service'
    },{
        name: 'description',
        type: 'string',
        description: 'Additional information for the courier'
    },{
        name: 'service_type',
        type: 'string',
        description: 'Service category for the courier'
    },{
        name: 'shipping_type',
        type: 'string',
        description: 'Mode of transportation use for the shipments'
    },{
        name: 'shipment_duration_range',
        type: 'string',
        description: `Time of delivery based on courier's SLA`
    },{
        name: 'shipment_duration_unit',
        type: 'string',
        description: 'The unit of the delivery time'
    },{
        name: 'price',
        type: 'integer',
        description: 'Courier rate'
    }]
}]

export default RateObject
